const BASE_URL = "https://adtwsso.klabsindia.com/api";

export default BASE_URL;